import { render, staticRenderFns } from "./RentObjectRatings.vue?vue&type=template&id=9e68c3f8&scoped=true&lang=pug"
import script from "./RentObjectRatings.vue?vue&type=script&lang=js"
export * from "./RentObjectRatings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e68c3f8",
  null
  
)

export default component.exports